import React from 'react';
import Questions from '../components/Questions';


export const QuestionsPage = () => {
  return (
    <div>
      <Questions />
    </div>
  );
};

export default QuestionsPage;